import { useState } from 'react';

import { SupplierEditForm } from 'modules/suppliers/components';
import { useFetchSupplier } from 'modules/suppliers/hooks';
import { unwrapQuery } from 'src/core/api/unwrapQuery';

type Supplier = { id: string | undefined; name: string; url?: string };

type ExpenditurePanelHeaderSupplierFormProps = {
  supplier: { id: string | undefined; name: string; url?: string } | undefined;
  withDetails?: boolean;
  onCancel: () => void;
  onSubmit: (newSupplier: Pick<Supplier, 'id' | 'name'>) => void;
  isSupplierEditable?: boolean;
  isSupplierDetailsEditable?: boolean;
  withSupplierDprInformation?: boolean;
  canCreateSupplier?: boolean;
};

export const ExpenditurePanelHeaderSupplierForm = ({
  supplier,
  withDetails,
  onSubmit,
  onCancel,
  isSupplierEditable,
  isSupplierDetailsEditable,
  withSupplierDprInformation,
  canCreateSupplier,
}: ExpenditurePanelHeaderSupplierFormProps) => {
  const [internalSupplier, setInternalSupplier] = useState<
    Pick<Supplier, 'id' | 'name'> | undefined
  >(supplier);

  const fetchSupplierQuery = useFetchSupplier(
    withDetails || isSupplierDetailsEditable ? internalSupplier?.id : undefined,
  );
  const supplierData = unwrapQuery(fetchSupplierQuery);
  const supplierDetails = supplierData && {
    vatNumber: supplierData.supplierDetails?.legalInfos?.vatNumber,
    country: supplierData.supplierDetails?.address?.country,
  };

  return (
    <SupplierEditForm
      supplier={{
        ...internalSupplier,
        id: internalSupplier?.id ?? '',
        name: internalSupplier?.name ?? '',
        vatNumber: supplierDetails?.vatNumber ?? undefined,
        country: supplierDetails?.country ?? undefined,
      }}
      canCreateSupplier={canCreateSupplier}
      onSupplierSelected={(newSupplier) => {
        // Idempotency: do not update if supplier is the same
        if (!newSupplier || newSupplier.id === internalSupplier?.id) {
          return;
        }
        setInternalSupplier(newSupplier);
      }}
      onConfirm={() => internalSupplier && onSubmit(internalSupplier)}
      onCancel={onCancel}
      shouldDisplayDPRInformations={withSupplierDprInformation}
      isSupplierEditable={isSupplierEditable}
    />
  );
};
